<!-- 
  /**
 * @component KeyStyle
 * @description 键盘样式组件
 * @props {String} inputStr - 输入字符串
 * @data {Number} index - 当前索引
 * @data {Boolean} isWrong - 当前是否错误
 * @method currentStr - 获取当前字符串
 * @method removeKey - 移除按键
 * @method nextWord - 获取下一个单词
 * @method nextKey - 获取下一个按键
 */ 
-->
<template>
  <div class="key-style-container">
    <ProgressBar :progress="progress" />
    <div class="game-control-btn">
      <GameControlBtn />
    </div>
    <div class="word-list">
      <div class="word-list-con">
        <transition name="fade" mode="out-in">
          <div class="word-list-con-line">
            <div
              :class="{
                'is-active': indexWord == index,
                'is-right': indexWord < index,
                'is-active-wrong': indexWord == index && isWrong,
              }"
              v-for="(word, indexWord) in currentStr()"
              :key="'word' + indexWord"
              class="letter"
            >
              <template v-if="word === '↵'">
                <img class="return-icon" :src="returnIcon" alt="return" />
              </template>
              <template v-else>
                {{ word }}
              </template>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { isShiftInputing, isInputRight } from "@/components/common";
import returnIcon from "@/assets/images/btn-retur-blue.svg";
import ProgressBar from "./BarProgress.vue";
import GameControlBtn from "./GameControlBtn.vue";
import { EventBus } from "../index.vue";
export default {
  props: {
    inputStr: {
      type: Array,
      default: () => [],
    },
    canOperate: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ProgressBar,
    GameControlBtn,
  },
  data() {
    return {
      index: 0,
      groupIndex: 0,
      isWrong: false,
      timer: null,
      firstRightMap: {}, // 二维结构
      returnIcon,
      progress: 0,
    };
  },
  mounted() {},
  methods: {
    reset() {
      this.index = 0;
      this.groupIndex = 0;
      this.isWrong = false;
      this.firstRightMap = {};
      this.progress = 0;
    },
    /**
     * 获取当前字符串
     */
    currentStr() {
      if (!this.inputStr[this.groupIndex]) {
        return "";
      }
      const currentGroupStr = this.inputStr[this.groupIndex];
      return currentGroupStr;
    },
    /**
     * 移除按键
     */
    removeKey(key) {
      console.log("removeKey1:", key, this.canOperate);

      if (!this.canOperate) return;

      const currentStr = this.inputStr[this.groupIndex];
      if (!currentStr) return;

      if (isShiftInputing(currentStr[this.index], key)) {
        console.log("正在输入组合键");
        return;
      }

      const isRight = isInputRight(currentStr[this.index], key);
      const currentIndex = this.index;
      console.log("removeKey2:", key, isRight, currentIndex);

      if (isRight) {
        EventBus.$emit("inputRight");
        // 使用二维结构记录每组的正确状态
        if (!this.firstRightMap[this.groupIndex]) {
          this.firstRightMap[this.groupIndex] = {};
        }
        this.firstRightMap[this.groupIndex][currentIndex] = true;

        clearTimeout(this.timer);
        this.isWrong = false;
        this.index++;

        if (currentStr.length <= this.index) {
          // 获取当前组的正确状态
          const correctStatus = Object.values(
            this.firstRightMap[this.groupIndex]
          );
          const isGroupCompleteRight = correctStatus.every((v) => v === true);

          // 触发当前组的正确事件
          if (isGroupCompleteRight) {
            this.$emit("inputRight", true);
            this.progress =
              ((this.groupIndex + 1) / this.inputStr.length) * 100;
          }

          // 检查是否所有组都完成
          if (this.groupIndex === this.inputStr.length - 1) {
            const resultData = this.getResultData();

            console.log("resultData:", resultData);

            // 这里可以添加最终完成判断逻辑
            this.$emit("finish", resultData);
          }

          // 重置状态，进入下一组
          if (this.groupIndex < this.inputStr.length - 1) {
            this.index = 0;
            this.groupIndex++;
          }
        }
      } else {
        EventBus.$emit("inputWrong");
        // 错误状态同样使用二维结构
        if (!this.firstRightMap[this.groupIndex]) {
          this.firstRightMap[this.groupIndex] = {};
        }
        this.firstRightMap[this.groupIndex][currentIndex] = false;

        this.isWrong = false;
        setTimeout(() => {
          this.isWrong = true;
        }, 0);
      }
    },
    /**
     * 获取当前按键
     */
    nextWord() {
      const currentStr = this.inputStr[this.groupIndex];
      return currentStr ? currentStr[this.index] : "";
    },
    /**
     * 获取下一个按键（永远是没敲的那一个）
     */
    nextKey() {
      const currentStr = this.inputStr[this.groupIndex];
      return currentStr ? currentStr[this.index] : "";
    },
    /**
     * 获取结果数据
     */
    getResultData() {
      const totalNum = this.inputStr.reduce(
        (acc, curr) => acc + curr.length,
        0
      );
      const correctNum = Object.values(this.firstRightMap).reduce(
        (acc, curr) => {
          return acc + Object.values(curr).filter(Boolean).length;
        },
        0
      );
      const resultData = {
        correctNum: correctNum,
        totalNum: totalNum,
        correctness: parseInt((correctNum / totalNum) * 100),
      };
      return resultData;
    },
  },
};
</script>

<style scoped lang="less">
// .progress-bar {
//   width: 72.5%;
//   height: 30px;
//   background-size: 100% 100%;
// }
.game-control-btn {
  position: fixed;
  top: 0;
  right: 0;
}
.key-style-container {
  width: 90%;
  // height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.word-list {
  width: 100%;
  max-width: 800px;
  height: auto;
  display: flex;
  overflow: hidden;
}
.word-list-con {
  display: flex;
  justify-content: center;
  min-width: 100%;
}
.word-list-con-line {
  display: flex;
  align-items: center;
}
.letter {
  color: #4a4a4a;
  background-image: url("../../../assets/game/images/bg-letter-common.png");
  background-size: 100% 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  // width: 57px;
  // height: 74px;
  width: 54px;
  height: 61px;
  margin-right: 18px;
  color: #00b0ff;
  font-size: 45px;
  font-weight: 800;
}
.letter:last-child {
  margin-right: 0;
}
.is-right {
  background-image: url("../../../assets/game/images/bg-letter-right.png");
  color: #6fd2ff;
  transition: color 0.12s ease-in-out;

  .return-icon {
    filter: invert(77%) sepia(11%) saturate(1005%) hue-rotate(64deg)
      brightness(120%) contrast(82%);
  }
}
.is-active {
  background-image: url("../../../assets/game/images/bg-letter-active.png");
  color: #fff;
  .return-icon {
    filter: brightness(0) invert(1);
  }
}
.is-active-wrong {
  background-image: url("../../../assets/game/images/bg-letter-wrong.png");
  border-color: #ffdcd9;
  border-radius: 5px;
  color: #fff;
  animation-name: shock;
  animation-duration: 0.7s;
  .return-icon {
    filter: brightness(0) invert(1);
  }
}

@keyframes shock {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-5px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(5px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.return-icon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  display: inline-block;
}
</style>
